import styles from './styles.scss';
import cn from 'classnames';
import { ReactNode } from 'react';
import { LoaderButton } from 'components/Button';
import { rm } from 'utils';

interface BaseProps {
  children: ReactNode;
}

interface BlueProps extends BaseProps {
  error?: boolean | string;
}

interface GreyProps extends BaseProps {
  error?: boolean | string;
  classname?: string;
}

export const BaseContainer = ({ children }: BaseProps) => (
  <div className={styles.base}>{children}</div>
);

export const BlueSectionContainer = ({ children, error = false }: BlueProps) => (
  <div className={cn(styles.blue, { [styles.error]: error })}>{children}</div>
);

export const GreySectionContainer = ({ children, error = false, classname }: GreyProps) => (
  <div className={cn(styles.grey, classname, { [styles.error]: error })}>{children}</div>
);

export const ErrorContainer = ({ children }: BaseProps) => (
  <div className={styles.error}>{children}</div>
);

export const SubmitContainer = ({ children }: BaseProps) => (
  <div className={styles.submitContainer}>{children}</div>
);

export const RadioBtnContainer = ({ children }: BaseProps) => (
  <div className={styles.radioBtnContainer}>{children}</div>
);

export const LoadingContainer = () => (
  <div className={styles.loadingContainer}>
    <h3>{rm('CustomerPage_Loading_Return_Title')}</h3>
    <LoaderButton appearance="tertiary" loading className={styles.loader} />
  </div>
);
